"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var HeaderCell_1 = tslib_1.__importStar(require("./HeaderCell"));
var tableDescriptorTypes_1 = require("../tableDescriptorTypes");
var ColumnGroupHeader = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnGroupHeader, _super);
    function ColumnGroupHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColumnGroupHeader.prototype.render = function () {
        var _a = this.props, menu = _a.menu, intl = _a.intl;
        var colGroupDef = this.props.columnGroup.getColGroupDef();
        var colId = tableDescriptorTypes_1.agColId(colGroupDef);
        var parent = this.props.columnGroup.getParent();
        // do not show menu for the first group header and empty headers above row attribute column headers
        var showMenu = !!parent && !!colGroupDef.headerName;
        return (react_1.default.createElement(HeaderCell_1.default, { className: "s-pivot-table-column-group-header", displayText: this.props.displayName, enableSorting: false, menuPosition: HeaderCell_1.ALIGN_LEFT, textAlign: HeaderCell_1.ALIGN_LEFT, menu: showMenu ? menu === null || menu === void 0 ? void 0 : menu() : undefined, onMenuAggregationClick: this.props.onMenuAggregationClick, colId: colId, getTableDescriptor: this.props.getTableDescriptor, getExecutionDefinition: this.props.getExecutionDefinition, getColumnTotals: this.props.getColumnTotals, intl: intl }));
    };
    return ColumnGroupHeader;
}(react_1.default.Component));
exports.default = ColumnGroupHeader;
//# sourceMappingURL=ColumnGroupHeader.js.map